import React, { useEffect } from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import payments from "assets/images/website/payments.PNG";
import imgCompound from "assets/images/totalCompound.png";
import imgUnit from "assets/images/totalUnit.png";
import { Link } from 'react-router-dom';
import { providerPrefix } from 'configs/routePrefix';
import { useDispatch, useSelector } from 'react-redux';
import { appendFilters } from 'store/adminFilter/actions';

const Cards = (props) => {
    const filter = useSelector(state=> state.adminFilter)
    const dispatch = useDispatch()
    const id = props?.match?.params?.id || localStorage.getItem('compound_id')
    
    useEffect(()=>{
        dispatch(appendFilters({compound_id: parseInt(id)}))
    },[])

    return ( 
        <div className='page-content'>
            <Container>
                <Row className='pt-2'>
                    <Col md={12} className='mb-2'>
                        <div className="d-flex mb-2">
                                <button className="p-0 m-0 border-0 me-2"
                                    style={{background: 'none'}}
                                    onClick={() => {
                                        //props.history.location.pathname
                                        props.history.push(`${providerPrefix}/Admin-developer/compound-list/${filter?.developer_id || localStorage.getItem('developer_id')}`)
                                    }}>
                                    <i className="fa fa-arrow-left text-success me-2 font-size-16"></i>
                                </button>
                            </div>
                    </Col>
                    <Col lg="6" md="6" className='pb-2'>
                        <Link to={`${providerPrefix}/Admin-developer/payment-plan/${id}`} onClick={()=> dispatch(appendFilters({path: 'fromCompound'}))}>
                            <Card>
                                <CardBody className='pb-3'>
                                    <img src={payments} width="50px"/>
                                    <h4 className='pt-3'>Manage Payment Plans</h4>
                                    <p className='text-muted'>You can manage all Payment plans for the selected compound</p>
                                </CardBody>
                            </Card>
                        </Link>
                    </Col>
                    <Col lg="6" md="6" className='pb-2'>
                        <Link to={`${providerPrefix}/Admin-developer/building`}  onClick={()=> {
                            localStorage.setItem('path', 'PropertiesInBuilding')
                            dispatch(appendFilters({path: 'PropertiesInBuilding'}))}}>
                            <Card>
                                <CardBody className='pb-3'>
                                    <img src={imgCompound} width="50px"/>
                                    <h4 className='pt-3'>Manage Buildings</h4>
                                    <p className='text-muted'>You can manage all buildings for the selected compound</p>
                                </CardBody>
                            </Card>
                        </Link>
                    </Col>
                    <Col lg="6" md="6" className='pb-2'>
                        <Link to={`${providerPrefix}/Admin-developer/property`} onClick={()=> {
                            localStorage.setItem('path', 'allProperties')
                            dispatch(appendFilters({building_id: null, path: 'allProperties'}))
                            }}>
                            <Card>
                                <CardBody className='pb-3'>
                                    <img src={imgUnit} width="50px"/>
                                    <h4 className='pt-3'>Manage All Properties</h4>
                                    <p className='text-muted'>You can manage all properties for the selected compound</p>
                                </CardBody>
                            </Card>
                        </Link>
                    </Col>
                    <Col lg="6" md="6" className='pb-2'>
                        <Link to={`${providerPrefix}/Admin-developer/property`} onClick={()=> {
                            localStorage.setItem('path', 'toStandaloneProperties')
                            dispatch(appendFilters({building_id: null, path: 'toStandaloneProperties'}))}}>
                            <Card>
                                <CardBody className='pb-3'>
                                    <img src={imgUnit} width="50px"/>
                                    <h4 className='pt-3'>Manage Standalone Properties</h4>
                                    <p className='text-muted'>You can manage standalone properties for the selected compound</p>
                                </CardBody>
                            </Card>
                        </Link>
                    </Col>
                </Row>
            </Container>
        </div>
     );
}
 
export default Cards;